import { computed, Directive, effect, HostBinding, input } from '@angular/core';

export enum SscButtonSize {
  extraSmall = 'extraSmall',
  small = 'small',
  normal = 'normal',
  large = 'large',
  extraLarge = 'extraLarge',
  huge = 'huge',
}

const BASE_CLASSES =
  'rounded-full w-fit min-w-fit duration-200 flex items-center justify-center gap-2 whitespace-nowrap text-center';

const SIZE_CLASSES: Record<SscButtonSize, string> = {
  [SscButtonSize.extraSmall]: 'h-8 py-1.5 px-3 text-sm',
  [SscButtonSize.small]: 'h-11 py-2 px-4 text-md',
  [SscButtonSize.normal]: 'h-14 py-3 px-5 text-md',
  [SscButtonSize.large]: 'h-16 py-3 px-6 text-md',
  [SscButtonSize.extraLarge]: 'h-18 py-4 px-7 text-lg',
  [SscButtonSize.huge]: 'h-20 py-5 px-8 text-xl',
};

@Directive({
  selector: '[sscButton]',
  standalone: true,
})
export class SscButtonDirective {
  size = input<SscButtonSize>(SscButtonSize.normal);

  #classSignal = computed(() => `${BASE_CLASSES} ${SIZE_CLASSES[this.size()]}`);

  @HostBinding('class') hostClass!: string;

  constructor() {
    effect(() => {
      this.hostClass = this.#classSignal();
    });
  }
}
